import { useLocation, useNavigate } from 'react-router-dom';
import ROUTERS from '../../constans/router';
import SkeletonLoadingComponent from '../SkeletonLoading';

type props = {
  videoDetail: Object,
  publishStatus: Boolean,
  classStyle: String,
  player: Boolean,
  isProcessing: Boolean,
  userInfo: Object,
  location: Object,
  params: Object
};

const ThumnailVideoComponent = ({
  videoDetail,
  publishStatus,
  classStyle,
  player,
  isProcessing,
  userInfo,
  location,
  params
}: props) => {

  //video thumb
  const navigate = useNavigate();

  const handleDetailVideo = (id) => {
    if (player) {
      navigate(ROUTERS.VIDEO_PLAYER_PATH(id), {state: {prevPath: 'prevPath', type: location?.state?.type || location}});
    } else {
      navigate(ROUTERS.VIDEO_DETAIL_PATH(id), {state: {prevPath: 'prevPath', type: location?.state?.type || location}});
    }
  };

  return (
    <>
      <label className={`video-selector ${classStyle ?? ''}`}>
        <input type="checkbox" />
        {isProcessing ? (
          <SkeletonLoadingComponent type={`video`} height={183}/>
        ) : (
          <div className="photo-selector__thumb">
            <img
              className="border-image width-height-image"
              src={videoDetail?.photo_url}
              alt=""
            />
            <div
              className="marker video-marker-date"
              onClick={() => {
                handleDetailVideo(videoDetail?.id || null);
              }}
            >
              <img src="/images/album/icon_play-btn.svg" alt="" />
            </div>

            {publishStatus &&
            videoDetail?.video_message?.published_at &&
            videoDetail?.video_message?.published_at !== null ? (
              <div className="text-image-top-red">
                <span>
                  {isProcessing ? <SkeletonLoadingComponent width={50} /> : '공개완료'}
                </span>
                <img
                  src="/images/album/icon_finish_star.svg"
                  className="mb-1"
                  alt=""
                />
              </div>
            ) : (
              publishStatus && (
                <div className="text-image-top">
                  {isProcessing ? <SkeletonLoadingComponent width={70} /> : '미공개'}
                </div>
              )
            )}
          </div>
        )}
      </label>
    </>
  );
};

ThumnailVideoComponent.defaultProps = {
  publishStatus: true,
  classStyle: '',
  player: false,
};
export default ThumnailVideoComponent;
